import type { RateCategoryConfig } from '../../../domain/types/configs/company/RateCategoryConfig';

export const rateCategoryConfig: RateCategoryConfig = {
  rateCategory: [
    {
      label: "Air Outbound",
      value: "air_outbound"
    },
    {
      value: "air_inbound",
      label: "Air Inbound"
    },
    {
      label: "Ocean Outbound",
      value: "ocean_outbound"
    },
    {
      value: "ocean_inbound",
      label: "Ocean Inbound"
    },
    {
      value: "warehouse_receipt",
      label: "Warehouse Receipt"
    },
    {
      label: "Warehouse Release",
      value: "warehouse_release"
    },
    {
      label: "Ground Outbound",
      value: "ground_outbound"
    },
    {
      label: "Ground Inbound",
      value: "ground_inbound"
    },
    {
      label: "Pickup",
      value: "pickup"
    },
    {
      value: "delivery",
      label: "Delivery"
    }
  ]
}; 